/**
 * Work typed on a screen and not saved yet, by the screen that holds it, so signing out can warn
 * before it is lost (Q09: products holding unsaved work warn before leaving). A screen holds an entry
 * while its work differs from what is saved and releases it when it is saved, undone or unmounted.
 */
export class Unsaved {
	#held = new Map<string, string>();

	/** Holds `name` (what the person would lose, as they know it) under `key` */
	hold(key: string, name: string): void {
		this.#held.set(key, name);
	}

	release(key: string): void {
		this.#held.delete(key);
	}

	/** The name of the first unsaved work, or undefined when nothing is unsaved */
	get first(): string | undefined {
		return this.#held.values().next().value;
	}
}
